(() => {
  const SELECTOR = '.ghg-mobile-buybar';

  function initBuyBar() {
    if (document.querySelector(SELECTOR)) return;

    const productInfo =
      document.querySelector('product-info[id^="MainProduct"]') ||
      document.querySelector('product-info');

    if (!productInfo) return;

    const getSubmitButton = () => productInfo.querySelector('product-form [type="submit"]');
    const getPriceText = () => {
      const price =
        productInfo.querySelector('[id^="price-"] .price-item--sale') ||
        productInfo.querySelector('[id^="price-"] .price-item--regular');
      return price?.textContent?.trim() || '';
    };

    const title =
      productInfo.querySelector('.product__title h1')?.textContent?.trim() ||
      document.querySelector('h1')?.textContent?.trim() ||
      '';

    const bar = document.createElement('div');
    bar.className = 'ghg-mobile-buybar is-hidden';
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML = `
      <div class="ghg-mobile-buybar__meta">
        <strong class="ghg-mobile-buybar__title"></strong>
        <span class="ghg-mobile-buybar__price"></span>
      </div>
      <button type="button" class="button ghg-mobile-buybar__button">
        <span>Add to cart</span>
      </button>
    `;

    const titleNode = bar.querySelector('.ghg-mobile-buybar__title');
    const priceNode = bar.querySelector('.ghg-mobile-buybar__price');
    const barButton = bar.querySelector('.ghg-mobile-buybar__button');
    const barButtonText = barButton.querySelector('span');

    titleNode.textContent = title;
    document.body.appendChild(bar);

    let mainButton = getSubmitButton();

    const sync = () => {
      mainButton = getSubmitButton();
      priceNode.textContent = getPriceText();

      if (!mainButton) {
        barButton.disabled = true;
        return;
      }

      const disabled =
        mainButton.disabled ||
        mainButton.getAttribute('aria-disabled') === 'true';

      barButton.disabled = disabled;

      const text =
        mainButton.querySelector('span')?.textContent?.trim() ||
        mainButton.textContent?.trim() ||
        'Add to cart';

      barButtonText.textContent = text;
    };

    sync();

    barButton.addEventListener('click', () => {
      mainButton = getSubmitButton();
      if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
      mainButton.click();
    });

    const observer = new MutationObserver(() => requestAnimationFrame(sync));
    observer.observe(productInfo, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });

    const setupVisibilityObserver = () => {
      mainButton = getSubmitButton();
      if (!mainButton) {
        bar.classList.remove('is-hidden');
        return;
      }

      const visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          bar.classList.toggle('is-hidden', entry.isIntersecting);
        },
        { threshold: 0.15 }
      );

      visibilityObserver.observe(mainButton);
    };

    setupVisibilityObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyBar, { once: true });
  } else {
    initBuyBar();
  }

  document.addEventListener('shopify:section:load', initBuyBar);
})();